import { Runnable } from '@/models/Runnable';
import { TriggerParams } from '@/models/TriggerParams';

import PipelineStage from './PipelineStage';
import Workflow from './Workflow';

export enum PipelineStatus {
  ON_HOLD = 'on_hold',
  TRIGGERED = 'triggered',
  INITIALIZING = 'initializing',
  RUNNING = 'running',
  SUCCEEDED = 'succeeded',
  FAILED = 'failed',
  ABORTED = 'aborted',
  SUCCEEDED_WITH_ABORT = 'succeeded_with_abort',
}

export type PipelineAttempt = {
  id: string;
  numberInPipelineBuildScope: number;
  status: PipelineStatus;
  triggeredAt?: string | null;
  progress?: number;
};

export type Pipeline = Runnable<PipelineStatus, 'startedAt'> & {
  id: string;
  name: string;
  type: PipelineType;
  numberInAppScope: number;
  triggerParams: TriggerParams;
  stages?: PipelineStage[];
  workflows?: Workflow[];
  currentAttemptId: string;
  attempts?: PipelineAttempt[];
  remoteAccessEnabled?: boolean;
  commitViewUrl?: string;
  pullRequestViewUrl?: string;
  rebuildable: boolean;
};

export type PipelineType = 'staged' | 'dag';

export const isPipelineFinished = (status: PipelineStatus): boolean => {
  return [
    PipelineStatus.SUCCEEDED,
    PipelineStatus.FAILED,
    PipelineStatus.ABORTED,
    PipelineStatus.SUCCEEDED_WITH_ABORT,
  ].includes(status);
};
